import React, { Component, useEffect, useState } from 'react';
import { Radio, Checkbox, Row, Col, Input } from 'antd';
import './index.scss';

export default function FMSConfigOptions({
    onChange = () => {},
    defaultOptions = {
        renameBeforeProduction: false,
        moveToProductionByShootType: true,
        deliveryByShootType: false,
        shootTypesDeliveredFirst: [],
    },
}) {
    const [optionType, setOptionType] = useState('default');
    const [config, setConfig] = useState({
        renameBeforeProduction: false,
        moveToProductionByShootType: true,
        deliveryByShootType: false,
        shootTypesDeliveredFirst: [],
    });

    const isDefaultConfig = () => {
        if (
            config?.renameBeforeProduction == false &&
            config?.moveToProductionByShootType == true &&
            config?.deliveryByShootType == false &&
            config?.shootTypesDeliveredFirst?.length == 0
        ) {
            setOptionType('default');
        } else {
            setOptionType('custom');
        }
    };

    useEffect(() => {
        console.log('use effect', { config });
        onChange(config);
        isDefaultConfig();
    }, [config]);

    const allShootTypes = ['OnModel', 'Ghost', 'Flatlay', 'PD_Bags', 'PD_Shoes', 'PD_Accessories'];

    const moveToGatiCheckChanged = ({ target }) => {
        const isChecked = target.checked;

        setConfig(prevValue => {
            const updateObj = {
                moveToProductionByShootType: isChecked,
            };

            if (isChecked == false) {
                updateObj['deliveryByShootType'] = false;
                updateObj['shootTypesDeliveredFirst'] = [];
            }

            const newValue = {
                ...prevValue,
                ...updateObj,
            };
            return newValue;
        });
    };

    const priorityDeliveryCheckChanged = ({ target }) => {
        const isChecked = target.checked;
        setConfig(prevValue => {
            const updateObj = {
                deliveryByShootType: isChecked,
                shootTypesDeliveredFirst: [],
            };
            const newValue = {
                ...prevValue,
                ...updateObj,
            };
            return newValue;
        });
    };

    const shootTypeCheckChange = ({ target }, shootType) => {
        const isChecked = target.checked;
        setConfig(prevValue => {
            let newValue = [];
            if (isChecked) {
                const shootTypes = Array.from(new Set([...prevValue.shootTypesDeliveredFirst, shootType]));
                const updateObj = {
                    shootTypesDeliveredFirst: shootTypes,
                };
                newValue = {
                    ...prevValue,
                    ...updateObj,
                };
            } else {
                const shootTypes = prevValue.shootTypesDeliveredFirst.filter(d => d != shootType);
                const updateObj = {
                    shootTypesDeliveredFirst: shootTypes,
                };
                newValue = {
                    ...prevValue,
                    ...updateObj,
                };
            }

            // check if all items are selected remove the first item
            if (newValue?.shootTypesDeliveredFirst?.length == allShootTypes?.length) {
                newValue?.shootTypesDeliveredFirst.splice(0, 1);
            }

            return newValue;
        });
    };

    const defaultClickHandler = e => {
        if (e.target.value == 'default') {
            setConfig(defaultOptions);
            setOptionType('default');
        }
    };

    const options = [
        {
            label: 'Default',
            value: 'default',
        },
        {
            label: 'Custom',
            value: 'custom',
        },
    ];

    return (
        <>
            <div className="container-fms-options">
                <Radio.Group options={options} optionType="button" buttonStyle="solid" value={optionType} onChange={defaultClickHandler} />
                <div className="container-1">
                    <Col span={24}>
                        <Checkbox checked={config.moveToProductionByShootType} onChange={moveToGatiCheckChanged}>
                            Move to gati by shoot type
                        </Checkbox>
                    </Col>
                    <Col span={24}>
                        <Checkbox
                            checked={config.deliveryByShootType}
                            onChange={priorityDeliveryCheckChanged}
                            disabled={!config.moveToProductionByShootType}
                        >
                            Priority shoot type delivery
                        </Checkbox>
                    </Col>
                    <div className="container-2">
                        <Col offset={2}>
                            {allShootTypes.map(shootType => (
                                <Col span={24}>
                                    <Checkbox
                                        disabled={!config.deliveryByShootType}
                                        checked={config.shootTypesDeliveredFirst?.includes(shootType)}
                                        onChange={e => {
                                            shootTypeCheckChange(e, shootType);
                                        }}
                                    >
                                        {shootType}
                                    </Checkbox>
                                </Col>
                            ))}
                        </Col>
                    </div>
                </div>
            </div>
        </>
    );
}
